import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import { chain } from 'lodash'
import config from '../../config'
import Loader from 'react-loader'
import CSSModules from 'react-css-modules'
import format from '../../helpers/format'
import { asyncConnect } from 'redux-async-connect'
import container from '../../helpers/container'
import convert from '../../helpers/convert'
import analytics from '../../helpers/analytics'
import {Row, Col} from 'react-flexbox-grid'
import chroma from 'chroma-js'
import ReactTooltip from 'react-tooltip'
import {SlideDown} from 'react-slidedown'
import {
  ContainerDivs,
  CompanyProfileModal,
  Chart,
  FlaggedFund,
  Link,
  LinkIcon,
  Grade,
  Tweeter,
  FundName,
  FundShareTakeAction,
  InlineSignup,
  IyvScorecard
} from '../../components'
import * as searchActions from 'redux/modules/search'
// import Modal from 'react-modal'
import moment from 'moment'

const Styles = require('./FundWeaponInvestments.css')

const FirstPage = 5
const AllPage = 1000000

function mapFundHoldings(fHoldings){
  const fHoldingsMap = {}
  fHoldings.forEach((fholding)=>{
    fHoldingsMap[fholding.db_holding_id] = fholding
  })
  return fHoldingsMap
}

function filterHoldings(fHoldingsMap, holdings, filterFn){
  return chain(holdings)
  .filter(filterFn)
  .sortBy((o)=>{
    return fHoldingsMap[o.id].market_value * -1
  })
  // .take(10)
  .value()
}

const propStateMap = [
  // { state:'screen', prop:'screen', transform:(value)=>value }
]

// // convert query props to state
const stateFromProps = (props) => {
  // defaults
  const state = {
    screen: 'all',
    location: props.location
  }

  propStateMap.forEach((map) => {
    // in map
    if (props.location.query[map.prop]) {
      // has value after transform
      const value = map.transform(props.location.query[map.prop])

      if (typeof value !== 'undefined' && value !== null) {
        state[map.state] = value
      }
    }
  })

  return state
}

@connect(
  state => ({
    result: state.shareClass.result,
    loading: state.shareClass.loading,
    loaded: state.shareClass.loaded,
    error: state.shareClass.error,
    // sector: state.sector.result
  }),
  searchActions)

@asyncConnect([{
  deferred: true, // need otherwise cient navigate is blocked until the page is loaded
  promise: ({params, store: {dispatch, getState}}) => {
    return dispatch(searchActions.shareClassDetails(params.fundId, params.investmentVehicleId))
  }
}])

@CSSModules(Styles, {allowMultiple:true})
export default class FundWeaponInvestments extends Component {
  static propTypes = {
    loading: PropTypes.bool,
    loaded: PropTypes.bool,
    error: PropTypes.object,
    result: PropTypes.object,
    // sector: PropTypes.object
  }

  static contextTypes =  {
    router: PropTypes.object.isRequired
  }

  constructor(props) {
    super(props)
    this.state = Object.assign(stateFromProps(props), {
      weaponsPage: 1,
      activeSector: '',
      viewMore: false,
    })
  }

  componentWillMount() {
    if (typeof window !== 'undefined') {
      window.scrollTo(0,0)
    }
  }

  componentDidMount() {
    analytics.event(
      analytics.eventLoadFund(
        this.props.params.fundId,
        this.props.params.investmentVehicleId
      )
    )
  }

  componentWillReceiveProps(props) {
    const ele = document.getElementById('anchor-top')
    window.scrollTo(ele.offsetLeft,ele.offsetTop)
  }

  componentWillUnmount() {}

  getChartData = (fund, weaponHoldings, fHoldingsMap) => {
    const label = 'military weapon'
    const capitalizedLabel = 'Military weapon'
    // colors
    const colors = {
      'mmc':'#C3001C',
      'mmc_end':'#C3001C',
      'cm':'#C3001C',
      'cm_end':'#C3001C',
      'nw':'#C3001C',
      'nw_end':'#C3001C',
      'weapons':'#333',
      'weapons_lite':'#333',
      'gray':'#D5D5D5',
      'green':'#D5D5D5'
    }
    // what categories are active?
    const activeSector = this.state.activeSector
    const allAsset = convert.int(fund.wff_mil_asset)
    const allWeight = format.perc(fund.wff_mil_weight)
    const fundRating = convert.float(fund.grade_military)
    let chartData = []

    if (activeSector && allAsset > 0) {
      // companies
      const num_colors = convert.int(fund[activeSector+'_count'])
      const scaleStart = colors[activeSector]
      let scaleEnd = colors[activeSector+'_end']
      if (weaponHoldings.length === 1) {
        scaleEnd = scaleStart
      }
      const f = chroma.scale([scaleStart,scaleEnd]).mode('rgb').colors(num_colors)
      // const shuffled = format.shuffle(f)
      let currIdx = -1
      // // map holdings to pie chart data
      chartData = weaponHoldings.reduce( (filtered, holding) => {
        const nameLabel = format.longString(holding.security_name, 20)
        const moneyLabel = format.money(fHoldingsMap[holding.id].market_value, true, 'USD', true)
        currIdx = (currIdx + 1) % num_colors
        filtered.push({
          value: fHoldingsMap[holding.id].market_value,
          label: nameLabel + ' ' + moneyLabel,
          color: f[currIdx]
        })
        return filtered
      }, [])
    } else {
      if (allAsset > 0) {
        const isLite = (fundRating === 2.0)
        chartData = [{
          value: allAsset,
          label: capitalizedLabel + ': '+allWeight,
          color: isLite ? colors.weapons_lite : colors.weapons
        },{
          value: convert.int(fund.fund_net_assets) - allAsset,
          label: 'All other holdings',
          color: colors.gray
        }]
      } else {
        chartData = [{
          value: 1,
          label: 'No ' + label + ' stock holdings',
          color: colors.green
        }]
      }
    }
    return chartData
  }

  clickViewMore = () =>{
    this.setState({viewMore: !this.state.viewMore})
  }

  clickSector(newSector){
    this.setState({
      activeSector: (newSector === this.state.activeSector) ? '' : newSector,
      weaponsPage: 1
    })
  }

  increment = (incState) => {
    return () => {
      const newState = {}
      newState[incState] = this.state[incState] + 1
      this.setState( newState )
    }
  }

  holdingsCount = (count) => {
    if (count > 0) {
      return format.number(count) + ' holdings'
    }
    return ''
  }

  renderSectors = (sector, fund, shareClass, fHoldingsMap) => {
    return (
      <div key={sector[0]}>
        { /* render the sector switch */
          this.renderSectorDetailsSwitch(
            sector[0],
            sector[1],
            sector[2],
            fund[sector[3]],
            fund[sector[4]],
            fund[sector[5]],
            shareClass.currency
          )
        }
        <SlideDown>
          { /* render the holding list if the sector is active */
            this.state.activeSector === sector[0] ?
              this.renderCompanies(
                shareClass,
                fHoldingsMap,
                sector[0],
                sector[1],
                shareClass[sector[3]],
                sector[6],
                this.state.weaponsPage
              ) :
              null
          }
        </SlideDown>
      </div>
    )
  }

  renderSectorDetailsSwitch = (type, label, sublabel, count, weight, asset, currency) => {
    // circle icon
    const iconNormal = require( '../../../static/images/icn-'+type+'-black.svg' )
    // circle icon filled in
    const iconActive = require( '../../../static/images/icn-'+type+'-active-black.svg' )
    // circle icon with green slash
    const iconClean = require( '../../../static/images/icn-'+type+'-inactive-slash.svg' )
    // clean or dirty?
    const isDirty = (convert.int(count))
    // currently active?
    const isActive = (type===this.state.activeSector)
    // what style?
    let currIcon = null
    let cleanDirtyStyle = ''

    if (isDirty) {
      if (isActive){
        cleanDirtyStyle = 'detail-sector-'+type+'-active'
        currIcon = iconActive
      } else {
        cleanDirtyStyle = 'detail-sector-'+type+'-normal'
        currIcon = iconNormal
      }
    } else {
      cleanDirtyStyle = 'detail-sector-clean'
      currIcon = iconClean
    }

    const clickSectorFn = (sectorType) => {
      if (isDirty) {
        this.clickSector(sectorType)
      }
    }

    return (
      <div
        styleName='detail-sector-wrapper'
        onClick={ () => clickSectorFn(type) }
      >
        <div styleName={cleanDirtyStyle}>
          <div styleName='detail-sector-detail-icon-wrap'>
            <img
              styleName='detail-icon'
              src={currIcon}
              alt={label}
            />
          </div>
          <div styleName='detail-title-active'>
            <div><b>{label}</b></div>
            {
              sublabel ?
                (
                  <div styleName='detail-sublabel'>{ sublabel }</div>
                ) :
                null
            }
          </div>
          {
            isDirty ?
              (
                <div styleName='detail-sector-stat-wrapper'>
                  <div styleName='detail-stat-active'>
                    <div styleName='detail-stat-figure'>
                      { format.number(count) }
                    </div>
                    <div styleName='detail-stat-label'>holdings</div>
                  </div>
                  <div styleName='detail-stat-active'>
                    <div styleName='detail-stat-figure'>
                      { format.money(asset, true, currency, true) }
                    </div>
                    <div styleName='detail-stat-label'>invested</div>
                  </div>
                  <div styleName='detail-stat-active'>
                    <div styleName='detail-stat-figure'>
                      { format.perc(weight) }
                    </div>
                    <div styleName='detail-stat-label'>of portfolio</div>
                  </div>
                </div>
              ) :
              (
                <div styleName='single-badge-wrap'>
                  <div styleName='single-badge-text'>
                    <div styleName='single-badge-title'>
                      0 direct stock holdings
                    </div>
                  </div>
                </div>
              )
          }
        </div>
      </div>
    )
  }

  renderCompanies = (shareClass, fHoldingsMap, type, label, count, holdings, page) => {
    const _count = convert.int(count)
    if (_count === 0) {
      return null
    }
    //
    return (
      <Col xs={12} styleName='detail-holdings-wrapper'>
        <div styleName='detail-fossils'>
          <div styleName='detail-title-holdings'>
            <div styleName={'detail-title-'+type}>
              {label}
            </div>
            <div styleName={'visible-sm visible-md visible-lg detail-holdings-count-'+type}>
              { this.holdingsCount(_count) }
            </div>
          </div>
          <div styleName={'visible-xs mobile-holdings-label'}>
            {_count} holdings
          </div>
          <ul styleName='detail-holdings'>
            { this.renderHoldings(shareClass, fHoldingsMap, holdings, page) }
          </ul>
        </div>
        {
          page === 1 && _count > FirstPage ?
            (
              <div
                styleName={'detail-more-'+type}
                onClick={ this.increment('weaponsPage') }
              >
                See all<LinkIcon faclass='fa-angle-down'/>
              </div>
            ) :
            null
        }
      </Col>
    )
  }

  renderHoldings = (shareClass, fHoldingsMap, holdings, page) => {
    if( !holdings || holdings.length === 0 ){
      return ( <div styleName='holdings-none'>NONE</div> )
    }

    const takeCount = (page > 1) ? AllPage : FirstPage

    // const iconMmc = require( '../../../static/images/icn-mmc-black.svg' )
    const iconNw = require( '../../../static/images/icn-nw-no-circle-black.svg' )
    const iconCm = require( '../../../static/images/icn-cm-no-circle-black.svg' )

    const iconConfigs = [
      // ['is_mmc', iconMmc, 'Major military contractors'],
      ['is_nw', iconNw, 'Nuclear weapons'],
      ['is_cm', iconCm, 'Controversial weapons'],
    ]

    return chain(holdings)
      .take(takeCount)
      .map( (h,idx) =>{
        const fPerc = format.perc(fHoldingsMap[h.id].long_weight)
        const fMoney = format.money(
          fHoldingsMap[h.id].market_value,
          true,
          shareClass.currency,
          true
        )
        return <li key={idx} >
          <CompanyProfileModal holding={h}>
            <div styleName='holding'>
              <div styleName='holding-name-wrap'>
                <span styleName='holding-modal-open-icon'>
                  <LinkIcon faclass='fa-angle-right' />
                </span>
                {idx+1}.
                &nbsp;
                <b>{h.security_name}</b>
              </div>
              <div styleName='holding-figures'>
                <div>
                  { /* mini-sector icons */
                    iconConfigs.map((sector)=>{
                      return <span
                        key={sector[0]}
                        title={sector[2]}
                      >
                        { 
                          h[sector[0]] ? 
                            <img
                              styleName='detail-icon-holding'
                              src={sector[1]}
                              alt={sector[2]}
                            /> :
                            <div styleName='detail-icon-holding' />
                        }
                      </span>
                    })
                  }
                </div>
                <div styleName='holding-invested'>
                  {fMoney}
                </div>
                <div styleName='holding-asset'>
                  {fPerc}
                </div>
              </div>
            </div>
          </CompanyProfileModal>
        </li>
      })
      .value()
  }

  renderStats = (shareClass) => {
    function renderCol(type, entries, hasLine) {
      return (
        <Col xs={6} styleName={'col-'+type+'-wrapper'}>

          {
            entries.map((entry,idx) => {
              return (
                <div
                  key={idx}
                  styleName='col-label-value'>

                  <div styleName={'col-'+type}>
                    <div styleName='stats-label'>{entry.name}</div>

                    {
                      (entry.link) ? (
                        <Link
                          to={entry.link}
                          title={entry.value}>
                          <div styleName='stats-value-link'>{entry.value}</div>
                        </Link>
                      ) : <div styleName='stats-value'>{entry.value}</div>
                    }

                  </div>

                  {
                    (hasLine && (idx !== entries.length-1)) ? (
                      <div styleName='col-line'/>
                    ) : null
                  }

                </div>
              )
            })
          }

        </Col>
      )
    }

    const dest = encodeURIComponent(shareClass.fund_family_name)

    return (
      <div styleName='stats'>
        <div styleName='stats-inner'>

          <Row styleName='stats-header'>
            <Col xs={12} sm={12} md={12} lg={12}>
              <div styleName='stats-title'>
                Mutual fund investment profile
              </div>
            </Col>
          </Row>

          <div styleName='line'/>

          <Row>
            { renderCol('left', [{name: 'Shareclass ticker', value:shareClass.ticker}], false) }
            { renderCol('right', [{name: 'Data as of', value:moment(shareClass.date.slice(0,10)).format('D MMM YYYY')}], false) }
          </Row>

          <div styleName='line'/>

          <Row>
            { renderCol('left', [{name: 'Shareclass name', value:shareClass.name}], false) }
            { renderCol('right', [{name: '% of fund assets screened', value:format.perc(shareClass.percent_rated) }], false) }
          </Row>

          <div styleName='line'/>

          <Row>
            { renderCol('left', [{name: 'Shareclass type', value:format.legalType(shareClass.legal_type)}], false) }
            { renderCol('right', [{name: 'Fund net assets', value:format.money(shareClass.fund_net_assets, true, shareClass.currency)}], false) }
          </Row>

          <div styleName='line'/>

          <Row>
            { renderCol('left', [{name: 'Fund family', link:config.routes.families+'/'+dest, value:shareClass.fund_family_name}], false) }
            { renderCol('right', [{name: 'Fund group', value:shareClass.category_group }], false) }
          </Row>

          <div styleName='line'/>

          <Row>
            { renderCol('left', [{name: 'Domicile country', value:format.market(shareClass.market)}], false) }
            { renderCol('right', [{name: 'Portfolio currency', value:format.currencyCode(shareClass.currency)}], false) }
          </Row>

          <div styleName='line'/>

          <Row>
            { renderCol('left', [{name: 'Sustainable investment', value:format.boolean(shareClass.ussif || '0')}], false) }
            { renderCol('right', [{name: '', value: ''}], false) }
          </Row>

          <div styleName='stats-totals'>
            <div styleName='stats-totals-header'>
              Military weapon totals
            </div>
            <div styleName='stats-total'>
              <div styleName='stats-total-name'>Total military weapon stock holdings</div>
              <div styleName='stats-total-value'>{ format.number(shareClass.wff_mil_count) }</div>
            </div>
            <div styleName='stats-total'>
              <div styleName='stats-total-name'>Total % invested in military weapon stocks</div>
              <div styleName='stats-total-value'>{ format.perc(shareClass.wff_mil_weight) }</div>
            </div>
            <div styleName='stats-total'>
              <div styleName='stats-total-name'>Total assets invested in military weapon stocks</div>
              <div styleName='stats-total-value'>
                { format.money(shareClass.wff_mil_asset, true, shareClass.currency, false) }
              </div>
            </div>
            <div styleName='stats-total'>
              <div styleName='stats-total-name'>Military weapon grade</div>
              <div
                styleName='profile-grade-title'
                data-multiline
                data-effect={'solid'}
                data-tip={format.weaponGradeTooltip('mil', format.score(shareClass.grade_military))}
                data-html
                data-place='left'
                data-for='tooltip-mil-grade'
              >
                <Grade grade={shareClass.grade_military} blocksmall/>
              </div>
              <ReactTooltip id='tooltip-mil-grade'/>
            </div>
          </div>
        </div>
      </div>
    )
  }

  render() {
    if( !this.props.result ){
      return (
        <div styleName='main'>
          <Loader
            options={{scale: 0.70, top:'2.0rem'}}
            loaded={ false }
          />
        </div>
      )
    } else if ( this.props.result && (!this.props.result.fund || !this.props.result.shareClass) ) {
      this.context.router.push(config.routes.notFound)
      return (
        <div styleName='main'>
          <Loader
            options={{scale: 0.70, top:'2.0rem'}}
            loaded={ false }
          />
        </div>
      )
    }

    // const sriIcon = require( '../../../static/images/sri.svg' )
    // const ussifIcon = require( '../../../static/images/ussif-memberlogo.png' )
    const iconGff = require( '../../../static/images/icons/gff-icn-clr.png' )

    function renderGradeBox(label, grd, screen) {
      const description = format.militaryGradeDescription(grd)

      return (
        <div styleName='grade-snapshot'>
          <div styleName='grade-intro'>
            <span>
              <strong>{label} grade:</strong> {description}
            </span>
            <br/>
            <Link
              strong
              to={config.routes.howitworks + '#military-weapon-grades'}
              title='Methodology'
            >
              <strong>
                How we track weapon investments<LinkIcon />
              </strong>
            </Link>
          </div>
          <div styleName='grade-wrapper'>
            <Grade grade={grd} large />
          </div>
        </div>
      )
    }

    const shareClass = this.props.result.shareClass
    const title = shareClass.fund_legal_name + ' | Weapon investments'
    const fund = this.props.result.fund
    const ticker = shareClass.ticker ? shareClass.ticker : 'N'
    const name = format.sanitize(shareClass.fund_legal_name)
    const urlStart = config.routes.fund+'/'+name+'/'+ticker
    const urlEnd = shareClass.fund_id+'/'+shareClass.investment_vehicle_id
    const url = config.domain+urlStart+'/weapon-investments/'+urlEnd

    // could this be cached (e.g. in state) to improve performance?
    const fHoldingsMap = mapFundHoldings(this.props.result.fund.fundholdings)
    const milHoldings = filterHoldings(fHoldingsMap, fund.holdings, (o)=>{
      return(o.is_mmc ||
             o.is_cm  ||
             o.is_nw)
    })
    const mmcHoldings = filterHoldings(fHoldingsMap, fund.holdings, (o)=>{
      return(o.is_mmc)
    })
    const nwHoldings = filterHoldings(fHoldingsMap, fund.holdings, (o)=>{
      return(o.is_nw)
    })
    const cmHoldings = filterHoldings(fHoldingsMap, fund.holdings, (o)=>{
      return(o.is_cm)
    })

    return (
      <div>
        {container.helmet(title, '', url)}
        <FundName
          shareClass={shareClass}
          pathname={this.props.location.pathname}
        />
        <div styleName='main'>
          <div styleName='snapshot-wrapper'>
            <div styleName='snapshot'>
              <Row>
                <Col xs={12} sm={12} md={4} styleName='chart-sidebar-wrap'>
                  { renderGradeBox(
                      'Military weapon',
                      fund.grade_military,
                      'mil'
                    )
                  }
                  { this.state.activeSector==='' ?
                      <Chart
                        chartMessage='Military weapons'
                        currency={shareClass.currency}
                        invested={convert.int(fund.wff_mil_asset)}
                        chartData={
                          this.getChartData(
                            fund,
                            milHoldings,
                            fHoldingsMap
                          )
                        }
                      /> : null
                  }
                  { this.state.activeSector==='mmc' ?
                      <Chart
                        chartMessage='Military contractors'
                        currency={shareClass.currency}
                        invested={convert.int(fund.mmc_asset)}
                        chartData={
                          this.getChartData(
                            fund,
                            mmcHoldings,
                            fHoldingsMap
                          )
                        }
                      /> : null
                  }
                  { this.state.activeSector==='nw' ?
                      <Chart
                        chartMessage='Nuclear weapons'
                        currency={shareClass.currency}
                        invested={convert.int(fund.nw_asset)}
                        chartData={
                          this.getChartData(
                            fund,
                            nwHoldings,
                            fHoldingsMap
                          )
                        }
                      /> : null
                  }
                  { this.state.activeSector==='cm' ?
                      <Chart
                        chartMessage='Controversial weapons'
                        currency={shareClass.currency}
                        invested={convert.int(fund.cm_asset)}
                        chartData={
                          this.getChartData(
                            fund,
                            cmHoldings,
                            fHoldingsMap
                          )
                        }
                      /> : null
                  }
                  <FlaggedFund
                    count={convert.int(fund.wff_mil_count)}
                    weight={convert.float(fund.wff_mil_weight)}
                    asset={convert.int(fund.wff_civ_count)}
                    portfolioDate={fund.date}
                    label='military weapon'
                  />
                </Col>
                <Col xs={12} sm={12} md={8} styleName='main-content-wrap'>
                  { convert.int(fund.wff_mil_count)===0 ?
                      <h2 styleName='flagged-fund-clean'>
                        Not invested in any of the companies on our lists
                      </h2> : null
                  }
                  { /* <div styleName='sector-details-info-label-energy'>
                    Military weapons
                  </div> */ }
                  { /* Sector switches + company lists */
                    [
                      [
                        'mmc',
                        'Military contractors',
                        'Largest international arms manufacturers and military contractors',
                        'mmc_count',
                        'mmc_weight',
                        'mmc_asset',
                        mmcHoldings
                      ],
                      [
                        'nw',
                        'Nuclear weapons',
                        'Manufacturers/servicers of nuclear armaments and delivery systems',
                        'nw_count',
                        'nw_weight',
                        'nw_asset',
                        nwHoldings
                      ],
                      [
                        'cm',
                        'Controversial weapons',
                        'Manufacturers involved with cluster munitions, landmines, white phosphorus, depleted uranium',
                        'cm_count',
                        'cm_weight',
                        'cm_asset',
                        cmHoldings
                      ],
                    ].map((sectorConfig)=>{
                      return this.renderSectors(
                        sectorConfig,
                        fund,
                        shareClass,
                        fHoldingsMap
                      )
                    })
                  }
                  { /* if flagged holdings and no selected sector */
                    (
                      convert.int(fund.wff_mil_count) &&
                      this.state.activeSector === ''
                    ) ?
                      this.renderCompanies(
                        shareClass,
                        fHoldingsMap,
                        'weapons',
                        'Military weapon companies',
                        shareClass.wff_mil_count,
                        milHoldings,
                        this.state.weaponsPage
                      ) :
                      null
                  }

                  <div styleName='sector-details-info'>
                    <LinkIcon faclass='fa-info-circle' nospace/>
                    &nbsp;
                    For each weapons category,
                    we show the fund's exposure.
                    When calculating a portfolio's percent exposure
                    to a list of companies,
                    we only consider long investments,
                    ignoring any shorts or liabilities.
                  </div>

                  { /* GUN FREE FUNDS */ }
                  <div styleName='hmi-icn-title'>
                    Civilian firearm manufacturers and retailers
                  </div>
                  <p>
                    We also track investments in civilian firearm manufacturers and
                    retailers raking in billions in handgun, assault rifle, and
                    ammunition sales. <b>Gun Free Funds</b> is made for people
                    looking to align their investments with their values by
                    moving money out of companies that make and sell guns.
                  </p>
                  <div styleName='hmi-icn-flex'>
                    <div styleName='hmi-icn-out' >
                      <Link
                        to='https://gunfreefunds.org'
                        title='Gun Free Funds'
                      >
                        <div styleName='hmi-icn-in'>
                          <img
                            src={iconGff}
                            alt='Gun Free Funds'
                          />
                          <div styleName='hmi-icn-lbl'>
                            <span styleName='gff'>Gun Free</span> Funds
                          </div>
                        </div>
                      </Link>
                    </div>
                    <p styleName='hmi-icn-link'>
                      <Link to='https://gunfreefunds.org' xstrong>
                        Visit Gun Free Funds<LinkIcon />
                      </Link>
                    </p>
                  </div>

                </Col>
              </Row>
              <div styleName='more-stats'>
                <div styleName='view-more-wrapper'>
                  <button
                    styleName='view-more'
                    title={
                      !this.state.viewMore ?
                        'View more info' :
                        'View less'
                    }
                    onClick={this.clickViewMore}
                  >
                    { !this.state.viewMore ? 'View more fund info' : 'View less' }
                    <LinkIcon
                      faclass={
                        this.state.viewMore ? 'fa-angle-up' : 'fa-angle-down'
                      }
                    />
                  </button>
                </div>
                <SlideDown>
                  {
                    this.state.viewMore ?
                      this.renderStats(shareClass) :
                      null
                  }
                </SlideDown>
              </div>
              <br/>
              <br/>
              <br/>
              <InlineSignup />

            </div>
          </div>
        </div>
        <IyvScorecard
          fund={fund}
          shareClass={shareClass}
        />
        <br/>
        <br/>
        <br/>
        <FundShareTakeAction
          fund={fund}
          shareClass={shareClass}
          url={url}
          screen='mil'
        />
      </div>
    )
  }
}
